import React, { useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { Link } from "react-router-dom";

function DigitalMarketing() {
const [openIndex, setOpenIndex] = useState<number | null>(0);

const toggleAccordion = (index: number) => {
setOpenIndex(openIndex === index ? null : index);
};

const services = [
  {
    title: "Social Media Marketing & Management",
    content:
      "We build and manage social media presence that goes beyond likes and followers. Our approach combines content strategy, creative execution, community management, and analytics to drive meaningful engagement. By understanding audience behaviour and platform dynamics, we create content calendars and campaigns that build brand relevance, consistency, and loyalty across Instagram, LinkedIn, Facebook, and other platforms.",
  },
  {
    title: "Performance Marketing & Paid Media",
    content:
      "Data-driven growth is at the core of our performance marketing services. We plan, execute, and optimize paid campaigns across Google, Meta, and other platforms to drive measurable results. From lead generation and conversions to app installs and sales, we focus on ROI through continuous testing, optimization, and insights. Every campaign is backed by clear KPIs and performance tracking.",
  },
  {
    title: "Search Engine Optimization (SEO)",
    content:
      "Visibility starts with discoverability. We optimize websites to rank higher on search engines through strategic keyword research, on-page optimization, technical SEO, and content enhancement. Our SEO approach focuses on long-term organic growth by improving site structure, relevance, and authority. The result is increased traffic, better search rankings, and sustained visibility in competitive markets.",
  },
  {
    title: "Content Marketing Strategy",
    content:
      "Content builds credibility and trust. We design content marketing strategies that educate, engage, and nurture audiences throughout the customer journey. From blogs and articles to case studies and thought leadership, our content is aligned with brand goals and SEO objectives. We ensure consistency in messaging while positioning brands as authorities in their respective industries.",
  },
  {
    title: "Email & Marketing Automation",
    content:
      "We create personalized email campaigns and automation workflows that nurture leads and retain customers. From newsletters and drip campaigns to CRM integrations and lifecycle communication, our strategies focus on relevance and timing. By combining creative messaging with data insights, we help brands build meaningful, long-term relationships while driving conversions and repeat engagement.",
  },
  {
    title: "Analytics, Insights & Optimization",
    content:
      "Growth requires clarity. We track, analyse, and interpret digital performance data to uncover actionable insights. Our analytics services help brands understand what's working, what's not, and where to optimize. By continuously refining strategies based on real-time data, we ensure better decision-making, improved efficiency, and consistent performance improvement across digital channels.",
  },
];

return (
<>
  <Header />

  <section
    className="container"
    style={{
      paddingTop: "80px",
      paddingBottom: "80px",
    }}
    >
    <p
        style={{
          marginTop: "20px",
          fontSize: "16px",
          color: "#888",
        }}
      >
        <Link to="/" style={{ color: "#111", textDecoration: "none" }}>
          Home
        </Link>

        {" / "}

        <Link
          to="/services"
          style={{ color: "#111", textDecoration: "none" }}
        >
          Services
        </Link>

        {" / "}  Digital Marketing & Performance Growth
      </p>
  
    <h1
      style={{
        marginTop: "40px",
        fontSize: "80px",
        lineHeight: "1.1",
        marginBottom: "100px",
      }}
    >
      <span style={{ fontWeight: "400" }}>
        Digital 
      </span>{" "}
      <span style={{ fontWeight: "200" }}>
        Marketing
      </span>

      <br />

      <span style={{ fontWeight: "400" }}>
       & Performance 
      </span>
        <span style={{ fontWeight: "200" }}>
          Growth
        </span>
    </h1>
    <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginTop: "40px",
    marginBottom: "90px",
  }}
>
  <span
    style={{
      fontSize: "20px",
      fontWeight: "400",
      color: "#111",
    }}
  >
    About service
  </span>

  <a
    href="#about-service"
    style={{
      width: "48px",
      height: "48px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "24px",
    }}
  >
    ↓
  </a>
</div>
  
    <div className="row">
      <div className="col-lg-5">
        <h2
          style={{
            fontSize: "40px",
            lineHeight: "1.1",
            marginBottom: "40px",
          }}
>
          <strong>Your</strong> Approach
          <br />
          <strong>and</strong> Work Specifics
          </h2>

        <p
          style={{
            color: "#777",
            lineHeight: "1.6",
            fontSize: "17px",
          }}
        >
         We blend creativity with data to drive growth.
Our digital marketing approach focuses on audience
insights, content strategy, paid media, SEO, and
performance optimization—ensuring brands don't just
get visibility, but real business results.
        </p>
        <div
  style={{
    display: "flex",
    alignItems: "center",
    gap: "20px",
    marginTop: "40px",
  }}
>
  <span
    style={{
      fontSize: "24px",
      fontWeight: "400",
      color: "#111",
    }}
  >
    View works
  </span>

  <a
    href="/portfolio"
    style={{
      width: "58px",
      height: "58px",
      borderRadius: "50%",
      background: "#e5e5e5",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textDecoration: "none",
      color: "#111",
      fontSize: "20px",
    }}
  >
    →
  </a>
</div>
      </div>

      <div className="col-lg-6 offset-lg-1">
        {services.map((service, index) => (
          <div key={index}>
            <div
              onClick={() => toggleAccordion(index)}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                cursor: "pointer",
                padding: "25px 0",
              }}
            >
              <h4
                style={{
                  margin: 0,
                  fontSize: "18px",
                }}
              >
                {service.title}
              </h4>
<div
  style={{
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    background: openIndex === index ? "#ff9800" : "#efefef",
    color: openIndex === index ? "#000" : "#666",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "20px",
    fontWeight: "300",
    transition: "all 0.3s ease",
  }}
>
  {openIndex === index ? "−" : "+"}
</div>

            </div>

            {openIndex === index && (
              <p
                style={{
                  color: "#777",
                  lineHeight: "1.5",
                  fontSize: "14px",
                  paddingBottom: "25px",
                }}
              >
                {service.content}
              </p>
            )}

            <hr />
          </div>
        ))}
      </div>
    </div>
  </section>
  <section
  style={{
    background: "#000",
    color: "#fff",
    padding: "120px 0",
    textAlign: "center",
    position: "relative",
  }}
>
  <div className="container">

    <h2
      style={{
        fontSize: "50px",
        lineHeight: "1.1",
        marginBottom: "30px",
      }}
    >
      <span style={{ fontWeight: "100", color: "#fff" }}>
        Where
      </span>{" "}
      <span style={{ fontWeight: "500", color: "#fff" }}>
        Creativity
      </span>{" "}
      <span style={{ fontWeight: "100", color: "#fff" }}>
        Meets
      </span>

      <br />

      <span style={{ fontWeight: "500", color: "#fff" }}>
        Strategic Execution
      </span>
    </h2>

    <p
      style={{
        maxWidth: "900px",
        margin: "0 auto 50px",
        color: "#bdbdbd",
        fontSize: "20px",
        lineHeight: "1.8",
      }}
    >
      Explore and gain a deeper understanding of the comprehensive
      range of services we offer, thoughtfully designed to meet your
      needs and deliver impactful, results-driven solutions across
      every stage of your business journey.
    </p>

    <a
      href="/contact"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "20px",
        background: "#ce5311",
        color: "#000",
        textDecoration: "none",
        padding: "20px 35px",
        borderRadius: "50px",
        fontWeight: "600",
        fontSize: "18px",
      }}
    >
      Contact Us

      <span
        style={{
          width: "50px",
          height: "50px",
          borderRadius: "50%",
          background: "#000",
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        →
      </span>
    </a>

  </div>
</section>
<section
  style={{
    padding: "120px 0",
    background: "#f5f5f5",
  }}
>
  <div className="container">

    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "50px",
      }}
    >
      <h2 style={{ margin: 0 }}>Other Services</h2>

      <a
        href="/services"
        style={{
          textDecoration: "none",
          color: "#111",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        View all
        <span
          style={{
            width: "35px",
            height: "35px",
            borderRadius: "50%",
            background: "#e5e5e5",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          →
        </span>
      </a>
    </div>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: "30px",
      }}
    >

      {/* Card 1 */}
      <div className="service-card">
        
      
<h3 style={{ 
  marginBottom: "30px",
  fontSize: "30px",
  lineHeight: "1.1",
 }}>
  Branding & Identity Design
</h3>

<p style={{ lineHeight: "1.8", marginBottom: "30px" , fontSize: "14px"}}>
  Creating powerful brand identities that inspire
  recognition, differentiation, and market distinction.
</p>

<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Brand Strategy & Positioning</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Logo Design & Visual Identity</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}  >Brand Guidelines & Playbooks</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Packaging & Label Design</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Rebranding & Brand Refresh</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Naming & Brand Architecture</p>

        <a
          href="/services"
          style={{
            marginTop: "40px",
            display: "inline-flex",
            alignItems: "center",
            gap: "15px",
            textDecoration: "none",
            color: "#000000",
            fontWeight: "600",
          }}
        >
          Read more
          <span className="read-more-circle">
            →
          </span>
        </a>
      </div>

      {/* Card 2 */}
      <div className="service-card">
        
      <h3 style={{ 
          marginBottom: "30px",
  fontSize: "30px",
  lineHeight: "1.1",
       }}>
  Digital Marketing & Performance Growth
</h3>

<p style={{ lineHeight: "1.8", marginBottom: "30px" , fontSize: "14px"}}>
  Driving measurable growth through targeted digital
  strategies, content, and performance-focused
  marketing solutions.
</p>

<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Social Media Marketing & Management</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Performance Marketing & Paid Media</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Search Engine Optimization (SEO)</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Content Marketing Strategy</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Email & Marketing Automation</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Analytics, Insights & Optimization</p>

        <a
          href="/services"
          style={{
            marginTop: "40px",
            display: "inline-flex",
            alignItems: "center",
            gap: "15px",
            textDecoration: "none",
            color: "#111",
            fontWeight: "600",
          }}
        >
          Read more
          <span className="read-more-circle">
          →
          </span>
        </a>
      </div>

      {/* Card 3 */}
      <div className="service-card">
      
      <h3 style={{ 
          marginBottom: "30px",
  fontSize: "30px",
  lineHeight: "1.1",
      }}>
  Web, UI/UX & Digital Experiences
</h3>

<p style={{ lineHeight: "1.8", marginBottom: "30px" , fontSize: "14px"}}>
  Designing intuitive digital experiences that enhance
  brand presence and convert audience interactions
  effectively.
</p>

<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Website Strategy & Information Architecture</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>UI/UX Design</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Website Design & Development</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>E-commerce Experiences</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Mobile App UI/UX Design</p>
<hr />
<p style={{ margin: "14px 0", 
        lineHeight: "1.6",
         color: "#111",
          fontSize: "14px"
        }}>Digital Product & Experience Design</p>  

        <a
          href="/services"
          style={{
            marginTop: "40px",
            display: "inline-flex",
            alignItems: "center",
            gap: "15px",
            textDecoration: "none",
            color: "#111",
            fontWeight: "600",
          }}
        >
          Read more
          <span className="read-more-circle">
          →
          </span>
        </a>
      </div>

    </div>
  </div>
</section>

  <Footer />
</>

);
}

export default DigitalMarketing;